import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';

const ElectricalBurns = ({ onNext, onBack }) => {
  const [checklist, setChecklist] = useState({});

  const considerations = [
    'Look for entry and exit wounds - widespread tissue damage',
    'Perform ECG - assess for cardiac arrhythmias',
    'Monitor for rhabdomyolysis - check urine myoglobin',
    'Continuous cardiac monitoring in initial hours',
    'Higher urine output goals (1-1.5 mL/kg/hr)',
    'Assess for falls or other trauma from shock'
  ];

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-black py-4">
      <div className="w-full max-w-sm mx-auto px-4">
        <div className="flex flex-col min-h-screen bg-zinc-900 rounded-3xl border-2 border-orange-500/30 shadow-2xl overflow-hidden">
          <div className="flex items-center justify-between p-4 border-b-2 border-orange-500/30">
            <Button onClick={onBack} variant="ghost" className="flex items-center gap-2 text-orange-500 text-lg font-bold">
              <ArrowLeft className="w-6 h-6" /> Back
            </Button>
            <h1 className="text-lg font-black text-orange-500">Electrical Burns</h1>
            <div className="w-16" />
          </div>

          <main className="flex-grow overflow-y-auto bg-black p-4 space-y-5">
            <div>
              <h2 className="text-2xl font-black text-orange-400 mb-2">Initial Assessment</h2>
              <p className="text-lg text-orange-100 leading-relaxed">
                Electrical burns can cause severe internal damage, often disproportionate to visible skin injury.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-black text-orange-400 mb-3">Key Considerations</h3>
              <div className="space-y-3">
                {considerations.map((consideration, index) => (
                  <label key={index} className="flex items-start p-4 rounded-2xl bg-zinc-900 border-2 border-orange-500/20 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={checklist[index] || false}
                      onChange={() => setChecklist(prev => ({ ...prev, [index]: !prev[index] }))}
                      className="h-7 w-7 mt-0.5 rounded border-2 border-orange-500 bg-transparent text-orange-500"
                    />
                    <span className="ml-4 text-lg text-orange-100 leading-snug">{consideration}</span>
                  </label>
                ))}
              </div>
            </div>
          </main>

          <div className="p-4 border-t-2 border-orange-500/30 bg-zinc-900">
            <Button onClick={onNext} className="w-full h-14 bg-orange-500 text-white text-lg font-black rounded-xl hover:bg-orange-600 shadow-xl">
              Return to Mechanism
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ElectricalBurns;
